import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { app_base_url } from "../../Utils/baseUrl";
import { INavigator } from "../MenuLateral/Index";
import { Container, LinkEstilizado } from "./styles";
import { User, Icon, Users, Home, HelpCircle, Image, Search } from "react-feather";
import { FaBuilding, FaLandmark, FaTractor } from "react-icons/fa";
import { retiraAcentos } from "../../Services/retiraAcentos";
import RelatorioIcone from "../../Assets/relatorios.png";
import Celeiro from "../../Assets/celeiro.png";


export function CustomerLink({ to, type }: INavigator) {
  const [focus, setFocus] = useState(true);
  function defineIcon() {
    let Icone: Icon = HelpCircle;
    if (type != "PREFEITURAS") {
      if (type == "PERFIL") {
        Icone = User;
      }

      if (type == "FUNCIONÁRIOS") {
        Icone = Users;
      }

      if (type == "IMÓVEIS") {
        Icone = Home;
      }
      if (type == "IMÓVEIS RURAIS") {
        //return <FaTractor size={"max(1.2vw, 12px)"} />;
        return <img src={Celeiro} style={{ width: "16px" }} />
       
      }

      if (type == "OPERAÇÕES") {
        Icone = HelpCircle;
      }

      if (type == "Cartórios") {
        return <FaBuilding size={"16px"} />;
      }

      if (type == "RELATORIOS") {
        return (
          <img src={RelatorioIcone} style={{ width: "16px" }} />
        );
      }

      return <Icone size={"16px"} />;
    }

    if (type == "PREFEITURAS") {
      return <FaLandmark size={"16px"} />;
    }

    if (type == "PESQUISAR") {
      return <Search size={"16px"} />;
    }
  }

  useEffect(() => {
    const url = window.location.href.split("/");
    console.log(url[url.length - 1]);
    // window.alert(url[url.length - 1] + "|" +  retiraAcentos(type.replaceAll("-"," ").toLocaleLowerCase()))
    if (
      url[url.length - 1] ==
      retiraAcentos(type.replaceAll(" ", "-").toLocaleLowerCase())
    ) {
      setFocus(true);
    } else {
      setFocus(false);
    }
  }, [window.location.href]);

  return (
    <Container>
      <Link to={`${app_base_url}/${to}`} onClick={() => {}}>
        <LinkEstilizado focus={focus}>
          {defineIcon()} {type}
        </LinkEstilizado>
      </Link>
    </Container>
  );
}
